import Mine from 'pages/mine';
import List from 'pages/list';
import Data from 'pages/data';
import InviteList from 'pages/invite-list';
import TimeDetail from 'pages/time-detail';
import DiamondReward from 'pages/diamond-reward';
import UserAgreement from 'pages/userAgreement';
import Page from 'pages/page';
import { createHashRouter, RouterProvider } from 'react-router-dom';
import Privacy from 'pages/privacy';

const baseUrl = process.env.NODE_ENV === 'development' ? '' : '/guild-pages';

export default createHashRouter([
  {
    path: '/',
    element: <Page></Page>,
  },
  {
    path: '/mine',
    element: <Mine></Mine>,
  },
  {
    path: '/members',
    element: <List type={'search'}></List>,
  },
  {
    path: '/invite',
    element: <List type={'invite'}></List>,
  },
  {
    path: '/data',
    element: <Data></Data>,
  },
  {
    path: '/time',
    element: <TimeDetail></TimeDetail>,
  },
  {
    path: '/invite-list',
    element: <InviteList></InviteList>,
  },
  {
    path: '/user-agreement',
    element: <UserAgreement></UserAgreement>,
  },
  {
    path: '/privacy',
    element: <Privacy></Privacy>,
  },
  {
    path: '/diamond-reward',
    element: <DiamondReward></DiamondReward>,
  },
]);
